import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

export function useDeployments(serverId: string) {
  const api = useApiClient();
  return useQuery({ queryKey: ['deployments', serverId], queryFn: () => api.deployments.list(serverId), refetchInterval: 60_000 });
}

/** Mounted only when the row is open, so it loads on demand */
export function useDeployment(serverId: string, id: string) {
  const api = useApiClient();
  return useQuery({ queryKey: ['deployment', serverId, id], queryFn: () => api.deployments.get(serverId, id) });
}

/** Starts the analysis session of a request (one session per repository and environment) */
export function useStartAnalysis(serverId: string) {
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deployments.startAnalysis(serverId, id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['deployments', serverId] });
    },
  });
}

/** Approves or rejects a waiting deployment on GitHub, under the operator's name */
export function useDecideDeployment(serverId: string) {
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: { id: string; state: 'approved' | 'rejected'; comment?: string; confirmDestroy?: number }) => api.deployments.decide(serverId, id, body),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['deployments', serverId] });
    },
  });
}
